// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductsWrapper_wrapper__pNpkc","divider":"ProductsWrapper_divider__pfO9I","products":"ProductsWrapper_products__ltAhu"};